import { Chip, Tooltip } from '@mui/material';
import { formatAgeLabel } from '../../utils/formatAge';

interface AgeChipProps {
  ageHours: number;
  expiredThreshold?: number;
  dangerThreshold?: number;
  warningThreshold?: number;
}

export default function AgeChip({
  ageHours,
  expiredThreshold = 72,
  dangerThreshold = Infinity,
  warningThreshold = 24,
}: AgeChipProps) {
  if (ageHours == null) {
    return (
      <Chip
        label="--"
        sx={{
          backgroundColor: '#f3f4f6',
          color: '#6b7280',
          fontWeight: 500,
          borderRadius: '10px',
        }}
      />
    );
  }

  const ageLabel = formatAgeLabel(ageHours);

  let chipColors = { main: '#6b7280', bg: '#f3f4f6' };
  let label = ageLabel;
  if (ageHours > expiredThreshold) {
    chipColors = { main: '#ef4444', bg: '#fef2f2' };
    label = 'Expired';
  } else if (ageHours > dangerThreshold) {
    chipColors = { main: '#ef4444', bg: '#fef2f2' };
  } else if (ageHours > warningThreshold) {
    chipColors = { main: '#F4C67A', bg: '#FFF8E5' };
  }

  return (
    <Tooltip title={ageLabel} arrow>
      <Chip
        label={label}
        sx={{
          backgroundColor: chipColors.bg,
          color: chipColors.main,
          fontWeight: 500,
          borderRadius: '10px',
        }}
      />
    </Tooltip>
  );
}
